export type FormattedPhone = {
  text: string;
  href: string;
};

export const formatPhone = (phone: string): FormattedPhone | undefined => {
  if (phone) {
    return {
      text: phone,
      href: `tel:${phone.replace(/\s+/g, '')}`,
    };
  }
  return undefined;
};
